export const FETCH_COLLEGES_START = "FETCH_COLLEGES_START";
export const FETCH_COLLEGES_SUCCESS = "FETCH_COLLEGES_SUCCESS";
export const FETCH_COLLEGES_FAIL = "FETCH_COLLEGES_FAIL";
export const FETCH_COLLEGES = "FETCH_COLLEGES";

export const FETCH_COLLEGE = "FETCH_COLLEGE";
export const FETCH_DETAIL_COLLEGE = "FETCH_DETAIL_COLLEGE";

export const SWITCH_PAGE = "SWITCH_PAGE";

export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const CONFIRM_FIRST_LOGIN = "CONFIRM_FIRST_LOGIN";
export const FETCH_BY_TOKEN = "FETCH_BY_TOKEN";
